export const getApplicationId = (contractNumber) => {
  return contractNumber
      ? contractNumber
      : "";
};
